import { type Board, SortDirection, type SubnavBoardSort } from '@air/types';
import { useCallback } from 'react';

import { type UsePrivateBoardsListParams } from '~/components/v2/hooks/queries/usePrivateBoardsList';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export type GetSubBoardsParamsParams = {
  parentBoard: Pick<Board, 'id'>;
  sort: SubnavBoardSort | undefined;
};

export type UseSubBoardsParams = {
  board: Pick<Board, 'id'>;
  open?: boolean;
};

export const useSubBoardsParams = () => {
  const { currentWorkspace } = useCurrentWorkspace();

  const getSubBoardsParams = useCallback(
    ({ parentBoard, sort }: GetSubBoardsParamsParams): UsePrivateBoardsListParams => {
      return {
        includeDirectDescendantCount: true,
        includeDirectDescendantBoardCount: true,
        isMemberOfBoard: 'ALL',
        view: parentBoard.id,
        numThumbnails: 0,
        includeAncestors: true,
        sortField: sort ?? {
          direction: SortDirection.desc,
          name: 'customSort',
        },
        workspaceId: currentWorkspace?.id,
      };
    },
    [currentWorkspace?.id],
  );

  return { getSubBoardsParams };
};
